import React, { useState } from "react";

const Card = ({ onClick, img, alt, productName, qty, discount, discountPrice, actualPrice }) => {
  const [isQtyLow, setIsQtyLow] = useState(() => qty < 6);

  return (
    <div className="card" onClick={onClick}>
      <div className="card-image">
        <img src={img} alt={alt} />
        <span className="tooltip">{discount} OFF</span>
      </div>
      <div className="card-body">
        <h5 className="card-title">{productName}</h5>
        <p className="stock-text"><span style={isQtyLow ? { color: '#FF0000' } : { color: '#026BB9' }}>{qty}</span> Produk Tersisa</p>
        <div className="card-description">
          <p className="discount">Rp. {discountPrice}</p>
          <p className="price">Rp. {actualPrice}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
